export const userActionTypes = {
    CURRENT_USER: "CURRENT_USER",
    TOGGLE_DROPDOWN: "TOGGLE_DROPDOWN"
};